import { utcToZonedTime } from 'date-fns-tz';
import type { TimeSlot } from '@minibook/shared';
import { DEFAULT_TIMEZONE } from '../constants/booking.js';
import { getIntlLocale } from '../formatting.js';

export function parseVkUserId(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const parsed = trimmed.replace(/^https?:\/\/(www\.)?vk\.com\//i, '').replace(/^id/i, '');
  return /^\d+$/.test(parsed) ? parsed : null;
}

export function isIsoUtc(value?: string | null): boolean {
  return !!value && /Z$/.test(value) && !Number.isNaN(Date.parse(value));
}

export function filterValidSlots(slots: TimeSlot[]): TimeSlot[] {
  return slots.filter((slot) => {
    if (!isIsoUtc(slot.startAt)) return false;
    if (slot.endAt != null) return isIsoUtc(slot.endAt);
    if (typeof slot.maxDurationMin === 'number' && slot.maxDurationMin >= 0) return true;
    return false;
  });
}

export function formatBookingSlotTime(
  isoString: string | undefined | null,
  timeZone: string | undefined,
  language: string
): string {
  if (!isoString) return '--:--';
  const tz = timeZone || DEFAULT_TIMEZONE;
  try {
    const zonedDate = utcToZonedTime(new Date(isoString), tz);
    const locale = getIntlLocale(language);
    return zonedDate.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', timeZone: tz });
  } catch {
    return '--:--';
  }
}
